import React, { useContext } from 'react';
import Loader from 'react-loader-spinner';
import { ThemeContext } from 'styled-components';

// Spinner global. A cor segue o TEMA (lightblue do palette, que casa com o
// --cco-blue do design CCO) em vez do azul legado #0A1F8F hardcoded — que
// destoava em todas as telas no dark theme. Prop `color` continua
// sobrescrevendo quando o consumidor precisar.
const LoaderComponent = ({ type, color, height, width }) => {
  const theme = useContext(ThemeContext);
  const themeColor =
    (theme && theme.colors && (theme.colors.lightblue || theme.colors.blue)) ||
    '#4EA1F3';
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Loader
        type={type || 'TailSpin'}
        color={color || themeColor}
        height={height || 50}
        width={width || 50}
      />
    </div>
  );
};

export default LoaderComponent;
